"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var airbridge_loader_1 = require("./library/airbridge_loader");
var flat_keys_1 = require("./library/flat_keys");
var throwBeforeInitError = function () {
    throw Error('Airbridge method is called before init');
};
var AirbridgeMock = ({
    init: function (options, callback) {
        airbridge_loader_1.default();
        var flatKeys = flat_keys_1.FlatKeys(AirbridgeMock);
        var _loop_1 = function (flatKey) {
            var method = flatKey.pop();
            var mockObject = flatKey.reduce(function (object, member) { return object[member]; }, AirbridgeMock);
            if (!method) {
                return "continue";
            }
            mockObject[method] = function () {
                var object = flatKey.reduce(function (object, member) { return object[member]; }, window.airbridge);
                object[method].apply(object, arguments);
            };
        };
        for (var _i = 0, flatKeys_1 = flatKeys; _i < flatKeys_1.length; _i++) {
            var flatKey = flatKeys_1[_i];
            _loop_1(flatKey);
        }
        window.airbridge.init(options, callback);
    },
    fetchResource: throwBeforeInitError,
    setBanner: throwBeforeInitError,
    setDownloads: throwBeforeInitError,
    setDeeplinks: throwBeforeInitError,
    sendSMS: throwBeforeInitError,
    sendWeb: throwBeforeInitError,
    setUserId: throwBeforeInitError,
    setUserEmail: throwBeforeInitError,
    setUserPhone: throwBeforeInitError,
    setUserAttributes: throwBeforeInitError,
    setUserAlias: throwBeforeInitError,
    events: {
        send: throwBeforeInitError,
        signIn: throwBeforeInitError,
        signUp: throwBeforeInitError,
        signOut: throwBeforeInitError,
        purchased: throwBeforeInitError,
        addedToCart: throwBeforeInitError,
        productDetailsViewEvent: throwBeforeInitError,
        homeViewEvent: throwBeforeInitError,
        productListViewEvent: throwBeforeInitError,
        searchResultViewEvent: throwBeforeInitError,
        wait: throwBeforeInitError,
    }
});
var airbridge = AirbridgeMock;
exports.default = airbridge;
//# sourceMappingURL=index.js.map